// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"contacts__wrapper--2HB4Y","imgWrapper":"contacts__imgWrapper--1U6v- contacts__wrapper--2HB4Y","textWrapper":"contacts__textWrapper--3VSrD contacts__wrapper--2HB4Y","img":"contacts__img--1DUCO","title":"contacts__title--29PDe thinBigText","address":"contacts__address--2Hvtv regularText","socials":"contacts__socials--PI9l7","contactButton":"contacts__contactButton--3EkFW formButton","header":"contacts__header--h5pn8 thinBigText"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Contacts/contacts.css
// module id = LHYS
// module chunks = 0